import {Drawer} from "@mui/material";
import {destroyModal, useModal} from "../../utils/modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faClock, faFire} from "@fortawesome/free-solid-svg-icons";
import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {TranslatedAttribute} from "../../../../utils";
import AllergenIcon from "../AllergenIcon";
import ProductForm from "../Product/ProductForm";

const LABEL_STYLES = {
  new: 'bg-green-100 text-green-800',
  star: 'bg-amber-100 text-amber-800',
  chefs_suggestion: 'bg-purple-100 text-purple-800',
};

const ProductDetailModal = () => {

  const modal = useModal();
  const {showProductOptions, locale, isOrderAvailable} = useSelector(state => state.app);
  const {t} = useTranslation();

  useEffect(() => {
      // console.log(showProductOptions, locale, isOrderAvailable)
  }, [])

  return (
    <>
      {
        <Drawer
          PaperProps={{
            sx: {
              backgroundColor: "transparent",
              boxShadow: 'none'
            }
          }}
          anchor={'bottom'}
          open={true}
          onClose={destroyModal}
        >

          <div
            className={'max-md:w-full max-md:max-w-[420px] md:mx-20 mx-auto bg-[#fff] h-full rounded-t-[30px] p-4 relative'}>
            <FontAwesomeIcon icon={faCircleXmark} size={'2x'}
                             className={'image-text-secondary w-[40px] h-[40px] absolute'} style={{right: 5, top: 5}}
                             onClick={destroyModal}/>
            <div
              className={'overflow-scroll no-scrollbar max-h-[70dvh] flex flex-col justify-start items-center mt-10 relative'}>

              {
                isOrderAvailable && modal.data.is_available && (
                  <div className={'w-full flex flex-col justify-center text-center'}>
                    <span className={'text-[22px] font-bold text-[#555555] mb-2'}>{t('general.add_to_cart')}</span>
                    <span className={'text-[16px] text-[#555555] mb-3'}>{t('general.product_detail_sub_title')}</span>
                  </div>
                )
              }


              {
                modal.data.full_size_url ? (
                  <div className={'mb-4'}>
                    <img src={modal.data.full_size_url} alt="" className={'w-full max-w-fit rounded-xl'}/>
                  </div>
                ) : (
                  <></>
                )
              }

              <div className={'flex flex-row my-2'}>
                {
                  (modal.data.ingredient_tags).map((tag, idx) => {
                    return (
                      <AllergenIcon key={`${idx}-${tag}`} tag={tag}/>
                    )
                  })
                }
              </div>

              {modal.data.labels && modal.data.labels.length > 0 && (
                <div className={'flex flex-row flex-wrap gap-1 my-1'}>
                  {modal.data.labels.map((label) => (
                    <span key={label} className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${LABEL_STYLES[label] || 'bg-gray-100 text-gray-700'}`}>
                      {t(`labels.${label}`)}
                    </span>
                  ))}
                </div>
              )}
              {
                modal.data.note && (
                  <div className={'bg-blue-100 px-2 py-0.5 rounded-xl text-xs mb-2 w-fit mt-2'}>
                    {t('general.note')}: {TranslatedAttribute(locale, modal.data, 'note')}
                  </div>
                )
              }

              <div className={'w-full'}>
                <div className={'flex flex-col'}>
                  <span className={'font-bold'}>{TranslatedAttribute(locale, modal.data, 'name')}</span>
                  <span
                    className={'font-normal text-[12px] mb-2'}>{TranslatedAttribute(locale, modal.data, 'description')}</span>
                  {modal.data.calorie && (
                    <div className={'flex flex-row items-center gap-1 text-[12px] text-orange-500 mb-2'}>
                      <FontAwesomeIcon icon={faFire} className={'text-orange-400'}/>
                      <span>{modal.data.calorie} {t('general.calorie')}</span>
                    </div>
                  )}
                </div>
                {
                  showProductOptions &&
                  <ProductForm item={modal.data}/>
                }
                {
                  modal.data.preparation_time ? (
                    <div className={'text-center flex items-center justify-center bg-[#f8f8f8] rounded-xl mt-4'}>
                      <span className={'m-2 text-sm'}>{modal.data.preparation_time} {t('general.minute')} </span>
                      <FontAwesomeIcon icon={faClock} className={'text-[#808080]'}/>
                    </div>
                  ) : (
                    <></>
                  )
                }

              </div>
            </div>

          </div>
        </Drawer>
      }
    </>
  )
}

export default ProductDetailModal;
